(function(window, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function () {
        const navigation = document.querySelector('nav');

        if (navigation && navigation.dataset.followNavigation === 'true') {
            /**
             * Überprüft beim scrollen, ob eine Section, die im Menü verlinkt ist, sichtbar ist und setzt einen Aktivstatus im Menü.
             */
            const followNavigation = () => {
                /**
                 * Überprüfe, ob ein Element im Viewport ist
                 *
                 * @param{HTMLElement} el
                 * @returns {boolean}
                 */
                const isElementInViewport = (el) => {
                    const rect = el.getBoundingClientRect();

                    return (
                        rect.top >= 0 &&
                        rect.left >= 0 &&
                        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                    );
                };

                /**
                 * Überprüft beim scrollen, ob eine Section, die im Menü verlinkt ist, sichtbar ist und setzt einen Aktivstatus im Menü.
                 */
                const followSectionForNavigation = () => {
                    const navigationLinks = Array.from(document.querySelectorAll('nav .nav-link'));

                    /**
                     * @param{HTMLElement} navigationLink
                     */
                    navigationLinks.forEach(navigationLink => {
                        const currentUrl = new URL(window.location);
                        const targetUrl = new URL(navigationLink.getAttribute('href'));
                        const refHash = targetUrl.hash;

                        if (
                            refHash
                            && refHash !== '#'
                            && currentUrl.origin === targetUrl.origin
                            && currentUrl.pathname === targetUrl.pathname
                        ) {
                            /** @type{HTMLElement} */
                            const refElement = document.querySelector(refHash);

                            if (refElement) {
                                if (isElementInViewport(refElement)) {
                                    navigationLinks.forEach(link => {
                                        link.classList.remove('active');
                                    });
                                    navigationLink.classList.add('active');
                                }
                            }
                        }
                    });
                }

                followSectionForNavigation();
                addEventListener('scroll', followSectionForNavigation, false);
                addEventListener('resize', followSectionForNavigation, false);
            }

            followNavigation();
        }
    });
})(window, window.PageLoadedQueue);
